define.alias("shared/components/shared/mobile/open-app", "media/components/shared/mobile/open-app");